var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white rounded-sm mx-2 my-3"},[_c('b-row',[_c('b-col',{staticClass:"overflow-hidden mb-2",attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',[_c('ActivityReport')],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }